import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/core/core.module';
import { FundsPortalService } from 'src/app/core/services/funds-portal.service';
import { AtramModalComponent } from 'src/app/shared/components/atram-modal/atram-modal.component';

@Component({
  selector: 'app-otp-sign-up',
  templateUrl: './otp-sign-up.component.html',
  styleUrls: ['./otp-sign-up.component.less']
})
export class OtpSignUpComponent implements OnInit {
  
  @ViewChild('atramModal')
  public atramModal: AtramModalComponent = new AtramModalComponent;

  public searchFormGroup!: FormGroup; 

  public openNav: boolean = false;
  public resendOTP: boolean = false;
  public isError: boolean = false;
  public isInvalidCode: boolean = false;
  public isNotValidInputs: boolean = false;
  public countDown: number = 60;
  public countDownTracker: string = "";
  public otpCode: string = "";
  public mobileNo: string = "";
  
  constructor(
    public fundsPortalService: FundsPortalService,
    public router: Router,
    public localStorageService: LocalStorageService
  ) { 
    
  }

  ngOnInit(): void {
    this.initializeFormGroup();
    this.validateInviteCode();
    this.timerNotice();
  }


  //#region Form Group Events
  initializeFormGroup(): void {
    this.searchFormGroup = new FormGroup({
      // expiryDate: new FormControl('', [Validators.required]),
      otp: new FormControl('', [Validators.required]),
      email: new FormControl('', [Validators.required])
    });
  }

  //#region service calls
  validateInviteCode(): Promise<any> {
    var body = {
      invite_code: this.localStorageService.get('email_code'),
    }

    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.validateInviteCode(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            if(data['response_data']['registration_session']['is_mobile_number_verified'] === true){
              this.router.navigateByUrl(``, { skipLocationChange: false });
            }
            else if(data['response_data']['registration_session']['mobile_number'] !== ''){
              this.mobileNo = data['response_data']['registration_session']['mobile_number'];
              return;
            }
            else if(data['response_data']['registration_session']['company_user'] !== null){
              this.router.navigateByUrl(`/sign-up/verify-number`, { skipLocationChange: false });
            }
            else if(data['response_data']['registration_session']['company_user'] === null){
              this.router.navigateByUrl(`/sign-up`, { skipLocationChange: false });
            }
            return;
          }
        },
        error: error =>{
          this.atramModal.show();
          this.atramModal.size = 'sm';
          this.atramModal.status = 'error';
          this.atramModal.headerText = 'Validation Failed';
          this.atramModal.bodyText = 'Incorrect Credentials';
          this.atramModal.okButtonText = 'Return';
          this.atramModal.showCancelButton = false;
          this.atramModal.showCloseButton = false;
          this.atramModal.confirmationSubject
            .subscribe((confirmation: boolean) => {
              if (confirmation) {
                // OK
              } else {
                // Cancel
              }
              this.atramModal.hide();
            });
        }
      })
    });
  }

  onOtpChange(e:any){
    this.searchFormGroup.get('otp')?.setValue(e);
    if(this.searchFormGroup.get('otp')?.value.length == 6)
      this.isError = false;
    
  }

  proceed(): void{
    if(this.searchFormGroup.get('otp')?.value.length < 6){
      this.isError = true;
      this.isNotValidInputs = true;
    }
    else{
      this.isNotValidInputs = false;
      this.submit();
    }
  }

  submit(): Promise<any> {
    let body = {  
        invite_code : this.localStorageService.get('email_code'),
        otp : this.searchFormGroup.get('otp')?.value
    }

    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.postValidateMobileNo(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            this.atramModal.show();
            this.atramModal.size = 'sm';
            this.atramModal.status = 'success';
            this.atramModal.headerText = 'Registration Successful';
            this.atramModal.bodyText = 'You can now log in to your account.';
            this.atramModal.okButtonText = 'Sign in';
            this.atramModal.showCancelButton = false;
            this.atramModal.showCloseButton = false;
            this.atramModal.confirmationSubject
              .subscribe((confirmation: boolean) => {
                if (confirmation) {
                  // OK
                  this.router.navigateByUrl(``, { skipLocationChange: false });
                } else {
                  // Cancel
                }
                this.atramModal.hide();
              });
            return;
          }
        },
        error: error =>{
          this.isInvalidCode = true;
        }
      })
    });
  }

  
  resendOTPCode(): Promise<any>{
    let body = {  
      invite_code : this.localStorageService.get('email_code')
    }
    return new Promise<any>((resolve: any, reject: any) => {
      this.fundsPortalService.postResendOtp(body)
      .subscribe({
        next: (data:any) =>{
          resolve(data);
          if (data['response_result'] === '0001'){
            this.resendOTP = false;
            this.countDown = 60;
            this.timerNotice();
            return;
          }
        },
        error: error =>{
          this.atramModal.show();
          this.atramModal.size = 'sm';
          this.atramModal.status = 'error';
          this.atramModal.headerText = 'OTP Resend Failed';
          this.atramModal.bodyText = 'Internal Error';
          this.atramModal.okButtonText = 'Return';
          this.atramModal.showCancelButton = false;
          this.atramModal.showCloseButton = false;
          this.atramModal.confirmationSubject
            .subscribe((confirmation: boolean) => {
              if (confirmation) {
                // OK
              } else {
                // Cancel
              }
              this.atramModal.hide();
            });
        }
      })
    });
  }

  timerNotice(){
    if(this.countDown >= 0){
      setTimeout(() => {
        if(this.countDown >= 10){
          this.countDownTracker = "00:" + this.countDown.toLocaleString();
        }
        else
        this.countDownTracker = "00:0" + this.countDown.toLocaleString();
        this.countDown--;
        this.timerNotice();
      }, 1000);
    }

    else{
      this.countDown = 60;
      this.resendOTP = true;
    }
  }

  goToVerifyNo(){
    this.router.navigateByUrl(`/sign-up/verify-number`, { skipLocationChange: false });
    if(this.localStorageService.get('isReverify') !== null){
       this.localStorageService.remove('isReverify');
    }
    this.localStorageService.set('isReverify', '1');
  }
}
